import React, { useState } from 'react';
import ContactLines from '../../components/ContactLines';
import { buildScript, formatDate, daysOut, PROMO_HANDOFF_DAYS } from './renewalHelpers';

// A Renewal Window card for the Retention Pipeline board (BK, 10/6/26: "build the full now").
// Same flow the old Renewal Reminders page had, in kanban-card size: confirm the membership in
// PlayByPoint first (unlocks the script), read the script, then log the outcome. The confirm
// step stays a hard gate — it is the last-mile safety net for comped/stale accounts the automatic
// exclusions can miss (docs/COMS_Renewal_Reminders_Build_Spec.md).
const BUCKET = { paying: ['PAYING', '#22c55e'], comped: ["COMP'D", '#f97316'], insurance: ['INSURANCE', '#14b8a6'] };

function Pill({ color, children }) {
  return (
    <span style={{
      background: `${color}22`, color, border: `1px solid ${color}`, fontSize: 9, fontWeight: 700,
      padding: '2px 6px', borderRadius: 4, textTransform: 'uppercase', letterSpacing: 0.4,
      marginRight: 4, display: 'inline-block', marginBottom: 4,
    }}>{children}</span>
  );
}

export default function RenewalWindowCard({ reminder, onConfirm, onLogOutcome }) {
  const [scriptOpen, setScriptOpen] = useState(false);
  const locked = !reminder.fd_confirmed_at;
  const is7 = reminder.touch_stage === '7_day';
  const isPromo = reminder.touch_stage === '14_day';   // promotion ending (11/3/26)
  const days = daysOut(reminder.current_period_end_at);
  const bucket = BUCKET[reminder.bucket];
  const urgent = is7 || (isPromo && days <= PROMO_HANDOFF_DAYS);
  const stageLabel = isPromo ? (days <= PROMO_HANDOFF_DAYS ? 'Promotion ending · last call' : 'Promotion ending') : is7 ? '7-Day touch' : '45-Day touch';
  const planPill = reminder.plan_length === 'annual' ? ['Annual', '#eab308']
    : reminder.plan_length === 'fixed_term' ? ['Does not renew', '#a855f7'] : ['Extended period', '#60a5fa'];

  return (
    <div style={{
      background: '#141414', border: '1px solid #2a2a2a', borderLeft: `3px solid ${urgent ? '#f97316' : '#3b82f6'}`,
      borderRadius: 7, padding: '7px 8px', marginBottom: 6,
    }}>
      <div style={{ fontWeight: 500, fontSize: 12, marginBottom: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {reminder.member_name || reminder.email}
      </div>
      <ContactLines phone={reminder.phone} email={reminder.email} name={reminder.member_name} size="xs" />
      <div style={{ marginBottom: 4 }}>
        <Pill color={urgent ? '#f97316' : '#3b82f6'}>{isPromo ? `${days} days left` : `${days} days out`}</Pill>
        <Pill color={planPill[1]}>{planPill[0]}</Pill>
        {bucket && <Pill color={bucket[1]}>{bucket[0]}</Pill>}
      </div>
      <div style={{ fontSize: 9.5, color: '#888', marginBottom: 4, lineHeight: 1.4 }}>
        {stageLabel} · {isPromo ? 'ends' : 'renews'} {formatDate(reminder.current_period_end_at)}
        {reminder.plan_name ? ` · ${reminder.plan_name}` : ''}
      </div>
      {is7 && !reminder.contacted_at && (
        <div style={{ fontSize: 9.5, color: '#f59e0b', marginBottom: 4 }}>45-day touch not yet logged</div>
      )}

      {scriptOpen && !locked && (
        <div style={{
          background: '#0f0f0f', border: '1px dashed #333', borderRadius: 6, padding: '7px 8px',
          fontSize: 11, color: '#bbb', lineHeight: 1.45, marginBottom: 6,
        }}>
          <div style={{ fontSize: 9, color: '#eab308', fontWeight: 700, marginBottom: 3 }}>SCRIPT</div>
          {buildScript(reminder)}
        </div>
      )}

      <div style={{ display: 'flex', gap: 4 }}>
        {locked ? (
          <button className="btn btn-ghost btn-sm" style={{ fontSize: 10, padding: '4px 6px', flex: 1 }}
            title="Open the member in PlayByPoint and confirm their membership status first — this unlocks the script"
            onClick={e => { e.stopPropagation(); onConfirm(reminder); }}>
            Confirm in PbP
          </button>
        ) : (
          <button className="btn btn-primary btn-sm" style={{ fontSize: 10, padding: '4px 6px', flex: 1 }}
            onClick={e => { e.stopPropagation(); setScriptOpen(o => !o); }}>
            {scriptOpen ? 'Hide script' : 'View script'}
          </button>
        )}
        <button className="btn btn-ghost btn-sm" style={{ fontSize: 10, padding: '4px 6px', flex: 1 }}
          onClick={e => { e.stopPropagation(); onLogOutcome(reminder); }}>
          Log outcome
        </button>
      </div>
      {locked && (
        <div style={{ fontSize: 9, color: '#666', marginTop: 4 }}>Confirm their status in PlayByPoint to unlock the script.</div>
      )}
    </div>
  );
}
